// removed by extract-text-webpack-plugin
module.exports = {"swiper-container-rtl":"swiper__swiper-container-rtl--2Ubqs","swiper-button-prev":"swiper__swiper-button-prev--1MKTK","swiper-preloader-spin":"swiper__swiper-preloader-spin--3eC2i"};


//////////////////
// WEBPACK FOOTER
// ./src/css/swiper.css
// module id = 61ly
// module chunks = 35